import { render, staticRenderFns } from "./B1.vue?vue&type=template&id=39942783&scoped=true"
import script from "./B1.vue?vue&type=script&lang=js"
export * from "./B1.vue?vue&type=script&lang=js"
import style0 from "./B1.vue?vue&type=style&index=0&id=39942783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39942783",
  null
  
)

export default component.exports